import UserData, { Annotations } from "@sabyr-dev/mist_core/lib/userdata";
import { ListItem } from "@sabyr-dev/mist_core/model/datasource/list";
import {
	Attempt, Product, Question, Quiz
} from "@sabyr-dev/mist_elibrary/datasource";

export interface AcademyAnnotations extends Annotations {
	status?: 'correct' | 'incorrect' | 'unanswered';
}

export class AcademyUserData extends UserData<Product, Attempt, Quiz, Question> {
	_parse(item: ListItem<Question>): AcademyAnnotations {
		const annotations = super._parse(item) as AcademyAnnotations;
		if (typeof (item.status) !== 'undefined') {
			annotations.status = item.status;
		}
		return annotations;
	}
}
